import { useMemo } from "react";
import { usePlatformStore } from "@platform/store";
import { useFetchUserMeetings } from "@core/features/videoMeeting";
import type { Meeting } from "@core/features/meeting";

export type UseUserMeetingsResult = {
  meetings: Meeting[];
  isLoading: boolean;
};

export function useUserMeetings(): UseUserMeetingsResult {
  const user = usePlatformStore((s) => s.user);
  const isHydrated = usePlatformStore((s) => s.isHydrated);
  const { data, isLoading } = useFetchUserMeetings({
    user,
    isEnabled: isHydrated,
  });

  const meetings = useMemo(() => {
    if (!data || !user) return [];
    return data.map((meeting) => {
      const participation = meeting.participants?.find(
        (p) => p.user.id === user.id,
      );
      return participation?.role
        ? { ...meeting, userRole: participation.role }
        : meeting;
    });
  }, [data, user]);

  return {
    meetings,
    isLoading,
  };
}

export default useUserMeetings;
